import React from "react";
import { Text } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { parseMentionSegments } from "./mentionFormat";
import { getMentionEntity } from "./constants/mentionEntities";
import Unicon from "@/components/General/Unicon";


//A single rendered mention token: module-colored, bold, with a small leading icon,
//tappable to navigate to the entity.
const MentionToken = ({ mention, router }) => {
    const { theme } = useUnistyles();
    if (!mention) return null;

    const entity = getMentionEntity(mention.type);
    const color = entity ? theme.colors[entity.color] : theme.colors.primary;
    const label = mention.label || "";

    const onPress = () => {
        if (!entity || !mention.id) return;
        router?.push(entity.route(mention.id));
    };

    return (
        <Text onPress={onPress} style={{ color, fontWeight: "bold" }}>
            {entity ? <Unicon name={entity.icon} size={12} color={color} /> : null}
            {entity ? " " : ""}{label}
        </Text>
    );
};

//Render text that may contain inline mention tokens (⟦type:id:label⟧) into an
//array of <Text> / <MentionToken> nodes suitable for placing inside a parent <Text>.
const renderTextWithMentions = (text, router) => {
    const segments = parseMentionSegments(text);
    if (!Array.isArray(segments)) return text ?? "";

    return segments.map((seg, i) => {
        if (seg.mention) {
            return <MentionToken key={`m-${i}`} mention={seg.mention} router={router} />;
        }
        return <Text key={`t-${i}`}>{seg.text}</Text>;
    });
};

export { renderTextWithMentions };
